var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0303 8.53025C16.1669 8.3888 16.2425 8.19935 16.2408 8.0027C16.239 7.80605 16.1602 7.61794 16.0211 7.47889C15.8821 7.33983 15.6939 7.26095 15.4973 7.25924C15.3007 7.25754 15.1112 7.33313 14.9697 7.46975L9.875 12.5645L7.40525 10.0948C7.2638 9.95813 7.07435 9.88254 6.8777 9.88424C6.68105 9.88595 6.49294 9.96483 6.35389 10.1039C6.21483 10.2429 6.13595 10.4311 6.13424 10.6277C6.13254 10.8243 6.20813 11.0138 6.34475 11.1553L9.34475 14.1553C9.4854 14.2959 9.67613 14.3748 9.875 14.3748C10.0739 14.3748 10.2646 14.2959 10.4052 14.1553L16.0303 8.53025ZM11 0.5C5.201 0.5 0.5 5.201 0.5 11C0.5 16.799 5.201 21.5 11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.201 16.799 0.5 11 0.5ZM2 11C2 6.02975 6.02975 2 11 2C15.9703 2 20 6.02975 20 11C20 15.9703 15.9703 20 11 20C6.02975 20 2 15.9703 2 11Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/greenTickIcon.7bcbab82421f26f9f3c751c5658ccee7.svg";
export { ForwardRef as ReactComponent };